<template>
  <el-card>


    <el-form inline :model="query" class="filter-form">
      <el-form-item label="型号查询:">
        <el-input v-model="query.name" placeholder="请输入型号" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
      <el-form-item>
        <router-link to="/model-create">
          <el-button type="primary" >添加</el-button>
        </router-link>
      </el-form-item>
    </el-form>

    <el-table class="table block" :data="collection" v-loading="loading">
      <el-table-column prop="name" label="型号" />
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-link type="primary" @click="showEdit(scope.row)" style="margin-right: 10px;">修改</el-link>
          <el-link type="danger" @click="remove(scope.row)" v-if="scope.row.serials.length == 0" >删除</el-link>
          <el-link type="danger" v-if="scope.row.serials.length > 0" disabled>删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />

    <el-dialog title="编辑型号" :visible.sync="dialogFormVisible">
      <el-form :model="editModel" ref="form" :rules="rules">
        <el-form-item label="活动名称" label-width="120px" prop="name">
          <el-input v-model="editModel.name" autocomplete="off" style="width: 300px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'

  const { mapGetters } = createNamespacedHelpers('serialModel')

  export default {
    data() {
      return {
        loading: true,
        dialogFormVisible: false,
        editModel : { name: '' },
        rules: {
          name: this.$formHelper.requiredRuleFactory('请填写型号名称'),
        },
        query: {
          number: '',
        }
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination'])
    },
    methods: {
      async queryCollection({ pagination = { limit: 20 } } = {}) {
        let query = {
          ...this.query,
        }

        try {
          this.loading = true
          await this.$store.dispatch('serialModel/collection', { query, pagination })
        } finally {
          this.loading = false
        }
      },
      async remove(model) {
        await this.$confirm('确认删除该型号？')
        try {
          this.loading = true
          await this.$store.dispatch('serialModel/remove', model)
        } finally {
          this.loading = false
          this.queryCollection()
          this.$message.success('型号删除操作完成')
        }
      },
      showEdit(model) {
        this.editModel = _.cloneDeep(model)
        this.dialogFormVisible = true
      },
      //编辑提交方法
      async submitEdit() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        await this.$store.dispatch('serialModel/update', this.editModel)
        await this.queryCollection()
        this.dialogFormVisible = false
        this.$message.success('编辑型号成功')
      }
    },
    async mounted() {
      await this.queryCollection()
      this.loading = false
    }
  }
</script>
